import classnames from 'classnames';
import { arrayOf, bool, func, number, oneOfType, string } from 'prop-types';
import React from 'react';
import Select from 'react-select';

import { optionShape } from '../../prop-types';
import getDatasetFromProps from '../../utils/get-dataset-from-props';

function findValue(value, options) {
  return value
    ? options.find(option => option.value === value) || { label: value, value }
    : '';
}

const customStyles = {
  menu: provided => ({
    ...provided,
    zIndex: 3000, // override default "z-index" to avoid overlap from the Uppy Dashboard
  }),
};

class SingleSelect extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(selectedOption) {
    const syntheticSyntheticEvent = {
      target: {
        value: selectedOption && selectedOption.value,
        name: this.props.name,
        type: 'singleselect',
        dataset: getDatasetFromProps(this.props),
      },
    };
    this.props.onChange(syntheticSyntheticEvent);
  }

  render() {
    const { className, value, options, readOnly, id, onChange, ...rest } =
      this.props;
    return (
      <Select
        styles={customStyles}
        placeholder={readOnly ? '' : 'Select…'}
        className={classnames('m-select', className)}
        classNamePrefix="m-select"
        inputId={id}
        options={options}
        value={findValue(value, options)}
        onChange={this.handleChange}
        {...rest}
        isDisabled={readOnly}
      />
    );
  }
}

SingleSelect.propTypes = {
  value: oneOfType([string, number, bool]),
  options: arrayOf(optionShape).isRequired,
  readOnly: bool,
  className: string,

  onChange: func,
  name: string,
  id: string,
};

SingleSelect.defaultProps = {
  value: '',
  readOnly: false,
  className: undefined,

  onChange: () => {},
  name: '',
  id: undefined,
};

export default SingleSelect;
